import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCarCrash, faClipboardListCheck, faShippingTimed } from '@fortawesome/pro-light-svg-icons';
import { ButtonModule } from 'primeng/button';
import { CarouselModule } from 'primeng/carousel';
import { SidebarModule } from 'primeng/sidebar';

import { SharedModule } from '@app/shared';
import { CreNgModule, SpinnerModule } from 'cre-ng';
import { WigAwardsComponent } from './wig-awards.component';

import { WigAwardsService } from './wig-awards.service';
import { WigAwardsMonthsComponent } from './wig-awards-months/wig-awards-months.component';
import { WigAwardsStatsComponent } from './wig-awards-stats/wig-awards-stats.component';

@NgModule({
  declarations: [WigAwardsComponent, WigAwardsMonthsComponent, WigAwardsStatsComponent],
  exports: [WigAwardsComponent, WigAwardsMonthsComponent, WigAwardsStatsComponent],
  imports: [
    ButtonModule,
    CarouselModule,
    CommonModule,
    CreNgModule,
    FontAwesomeModule,
    SharedModule,
    SidebarModule,
    SpinnerModule
  ],
  providers: [DatePipe, WigAwardsService],
})
export class WigAwardsModule {
  constructor(library: FaIconLibrary) {
    // Font Awesome Icons to consume
    library.addIcons(faCarCrash, faClipboardListCheck, faShippingTimed);
  }
}
